/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import FormDialog from '../../Components/Modal/modal.js';
import { DELETE_DIALOG, CANCEL_TEXT } from '../../Constants/strings.js'; // Adjust import based on your constants
import './deleteMap.scss'; // Adjust import based on your styles
import alertIcon from '../../Assets/images/svg/alert_icon.svg';

const DeleteDialog = ({
  handleCloseAction,
  selectedItem,
  handleDeleteAction,
  setIsDialogOpen,
  setRows,
  handleSnackbar,
  setIsEdit,
}) => {
  const content = DELETE_DIALOG;

  return (
    <FormDialog
      open={selectedItem !== null}
      title={content.TITLE_TEXT}
      dialogBodycontent={
        <div className="dialog-body-text">
          <div className="dialog-alert-icon">
            <img className="icon-image" src={alertIcon} alt="" />
          </div>
          <div className="dialog-message-text">{content.MESSAGE_TEXT}</div>
        </div>
      }
      PaperProps={{}}
      button2Action={() =>
        handleDeleteAction(
          selectedItem,
          setRows,
          setIsDialogOpen,
          handleSnackbar,
          setIsEdit,
        )
      }
      dialogCss="dialog-message"
      dialogPaperCss="delete-dialog-paper"
      width={360}
      height={205}
      button1Action={() => handleCloseAction(setIsDialogOpen, setIsEdit)}
      button1={CANCEL_TEXT}
      cancelButtonId={'cancel-' + content.BUTTON_ID}
      button2={content.BUTTON_TEXT}
      submitButtonId={content.BUTTON_ID}

    />
  );
};

DeleteDialog.propTypes = {
  handleCloseAction: PropTypes.func.isRequired,
  handleDeleteAction: PropTypes.func.isRequired,
  selectedItem: PropTypes.object.isRequired,
  setIsDialogOpen: PropTypes.func.isRequired,
  setRows: PropTypes.func.isRequired,
  handleSnackbar: PropTypes.func.isRequired,
  setIsEdit: PropTypes.func.isRequired,
};

export default DeleteDialog;
